/** Inland water reflects its surroundings; it does not inherit an ocean's
 * turquoise depth ramp. Shared by the surface ribbon and its distant proxy. */
import { sharedWaterUniforms } from './waterMaterial';

export function riverWaterUniforms(seaColor: [number, number, number]) {
  const u = sharedWaterUniforms(seaColor);
  // Restrained mineral colour beneath the mirror. Keep only a trace of the
  // planet's liquid hue, and no pale shallow band along the entire bank.
  u.uDeep.value.multiplyScalar(.06).addScalar(.064);
  u.uShallow.value.set(.115, .116, .100);
  u.uFoam.value.set(.70, .71, .67);
  u.uFoamWidth.value = .18;
  u.uFoamStr.value = .12;
  return u;
}

export const RIVER_SHADE_GLSL = /* glsl */ `
vec3 riverSky(vec3 sky) {
  // A horizon fog colour is not a full environment map. Beyond the local
  // mirror it supplies a subdued slate plane, not a blue painted channel.
  float value=dot(sky,vec3(.2126,.7152,.0722));
  return mix(vec3(value),sky,.16)*.40;
}
vec4 riverShade(vec3 N, vec3 V, float depth, vec3 environment, float energy, float shadow) {
  float lit=.16+.84*uDayLight;
  vec3 bed=mix(uShallow,uDeep,1.0-exp(-max(depth,0.0)*.55))*lit*shadow;
  float grazing=pow(1.0-clamp(dot(N,V),0.0,1.0),1.5);
  // Art-directed reflectance: broad banks/trees/sky remain legible through a
  // quiet surface. Do not attenuate the mirror again at golden hour.
  float reflection=mix(.42,.94,grazing)*mix(1.0,.86,energy);
  vec3 col=mix(bed,environment,reflection);
  float glint=pow(max(dot(N,normalize(uSunDir+V)),0.0),180.0);
  col+=uSunColor*glint*.10*uArtGlint*shadow;
  return vec4(col,1.0);
}
`;
